import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { filter } from 'lodash'

import Grid from '../../components/GridView'
import moment from 'moment'

const query = gql`
  query {
    documents {
      id
      cod
      type
      due_date
      metadata
      customer {
        id
        cod
        name
      }
      insurer {
        id
        cod
        name
      }
    }
  }
`
const withQuery = graphql(query)

export default compose(
  withQuery,
  withProps(({ data }) => {
    // console.log(data)

    const dataset = []
    if (data.documents) {
      const deadline = moment().add(20, 'days')
      const pending = filter(data.documents, doc =>
        moment(doc.due_date).isBetween(new Date(), deadline)
      )
      // console.log(pending)
      dataset.push(...pending)
    }

    return {
      columns: [
        {
          name: 'client',
          title: 'Cliente',
          getCellValue: row =>
            (row.customer && row.customer.name) ||
            (row.metadata && row.metadata.cpfs.join(';'))
        },
        {
          name: 'insurer',
          title: 'Seguradora',
          getCellValue: row =>
            (row.insurer && row.insurer.cod) ||
            (row.metadata && row.metadata.insurer)
        },
        { name: 'due_date', title: 'Vencimento', sort: 'asc', type: 'date' },
        {
          name: 'id',
          label: 'editar',
          to: '/documents',
          title: ' ',
          type: 'link'
        }
      ],
      extensions: [
        { columnName: 'id', width: 75, align: 'center' },
        { columnName: 'due_date', width: 150, align: 'center' },
        { columnName: 'insurer', width: 100, align: 'center' }
      ],

      dense: true,
      loading: data.loading,
      rows: dataset //filter(data.documents, doc => !doc.children) || []
    }
  })
)(Grid)
